import { RouteRecordRaw } from 'vue-router';
import { AdminLayout } from '@/widgets/admin-layout';

// Import all admin route modules
import { route as adminHomeRoute } from './admin-home';
import { route as adminPermissionsRoute } from './admin-permissions';
import { route as adminRolesRoute } from './admin-positions';
import { route as adminDepartmentsRoute } from './admin-departments';
import { route as adminBranchesRoute } from './admin-branches';
import { route as adminBranchEditRoute } from './admin-branch-edit';
import { route as adminBranchCreateRoute } from './admin-branch-create';
import { route as adminUsersRoute } from './admin-users';
import { route as adminMembersRoute } from './admin-members';
import { route as adminFunctionalActivitiesRoute } from './admin-functional-activities';

export const routeName = 'Admin';

export const route: RouteRecordRaw = {
  path: '/admin',
  component: AdminLayout,
  meta: {
    requiresAuth: true,
    permissions: [{ action: 'read', subject: 'Admin' }],
  },
  children: [
    adminHomeRoute,
    adminPermissionsRoute,
    adminUsersRoute,
    adminMembersRoute,
    adminBranchesRoute,
    adminRolesRoute,
    adminDepartmentsRoute,
    adminBranchEditRoute,
    adminBranchCreateRoute,
    adminFunctionalActivitiesRoute,
  ],
};
